import React from 'react'
import Navigation from './pageComponents/navbar'
import ContactForm from './pageComponents/contactform'
import Footer from './pageComponents/footer'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import greenCar from '../assets/greenCar.jpg';
import classic from '../assets/blueClassic.jpg';
import rig from '../assets/peterBilt.jpg'

function CarShow() {
  return (
    <>
        <Navigation />
        <Container>
          <Row style={{marginTop: '2rem'}}>
            <Col className="d-flex justify-content-center align-items-center" sm={12} md={12} lg={12} xl={12}>
              <h1>
                Crab Orchard Christian Mountain Games & Car Show
              </h1>
            </Col>
          </Row>
          <Row style={{marginTop: '2rem'}}>
            <Col className="d-flex justify-content-center align-items-center" sm={12} md={6} lg={6} xl={6}>
              <img src={greenCar} alt="" style={{maxWidth: '20rem', maxHeight: '20rem'}} className="img-fluid w-100 w-md-75 w-lg-50" />
            </Col>
            <Col sm={12} md={6} lg={6} xl={6}>
            <p style={{ lineHeight: '2.5' }}>
              The Crab Orchard Christian Mountain Games Classic Car Show is a celebration of horsepower, history, and hard-earned pride. From beautifully restored classics to eye-catching hot rods and roaring muscle cars, this show is all about honoring machines that tell a story. Whether it’s chrome that shines like new or paint that wears its age with character, every vehicle on display represents passion, craftsmanship, and countless hours in the garage.
            </p>
            </Col>
          </Row>
          <Row style={{marginTop: '2rem'}}>
            <Col sm={12} md={6} lg={6} xl={6}>
            <p style={{ lineHeight: '2.5' }}>
              This isn’t just a car show for Sunday cruisers — working iron is welcome too. Semi trucks, dump trucks, and other heavy-duty rigs are invited to roll in and show off alongside the classics. These trucks are a tribute to grit, industry, and the backbone of our communities, and they deserve just as much admiration as any polished show car. If it runs, rumbles, and makes people stop and stare, it belongs here.
            </p>
            </Col>
            <Col className="d-flex justify-content-center align-items-center" sm={12} md={6} lg={6} xl={6}>
              <img src={rig} alt="" style={{maxWidth: '20rem', maxHeight: '20rem'}} className="img-fluid w-100 w-md-75 w-lg-50" />
            </Col>
          </Row>
          <Row style={{marginTop: '2rem'}}>
            <Col className="d-flex justify-content-center align-items-center" sm={12} md={6} lg={6} xl={6}>
              <img src={classic} alt="" style={{maxWidth: '20rem', maxHeight: '20rem'}} className="img-fluid w-100 w-md-75 w-lg-50" />
            </Col>
            <Col sm={12} md={6} lg={6} xl={6}>
            <p style={{ lineHeight: '2.5' }}>
              Set against the backdrop of the Crab Orchard Christian Mountain Games, the car show adds another layer of excitement to an already unforgettable event. It’s a place for families, enthusiasts, and competitors to gather, swap stories, take photos, and appreciate everything from vintage steel to modern muscle. Whether you’re bringing a showpiece or just coming to admire the lineup, this is a celebration of vehicles, community, and the shared love of all things built to last.
            </p>
            </Col>
          </Row>
        </Container>
        <ContactForm />
        <Footer />
    </>
  )
}

export default CarShow